import type { Feature } from '@luna/gatekeeper';

export const creditCardLimitInfo: Feature = {
    enabled: true,
    _description:
        'Displays collapsible limit information table bellow the credit card header - supported by AT only (requires availableAmounts field)',
};
